import { UIUtil } from '@suntex.core/animation';

/**
 * Classic `UIUtil.globalToLocalXY` returned an `[x, y]` tuple. The modern
 * `@suntex.core/animation` `UIUtil.globalToLocal` returns a `createjs.Point`;
 * this preserves the tuple shape the VIF games were written against.
 */
export function globalToLocalXY(
  movieClip: createjs.DisplayObject,
  x: number,
  y: number,
): [number, number] {
  const p = UIUtil.globalToLocal(movieClip, x, y);
  return [p.x, p.y];
}

/**
 * Classic `UIUtil.playFrame(mc, frame)` had no modern equivalent; it simply
 * played a movie clip from the given frame. Preserves that behavior.
 */
export function playFrame(movieClip: createjs.MovieClip, frame: number): void {
  if (movieClip?.timeline) movieClip.gotoAndPlay(frame);
}
